import { Modal } from 'react-bootstrap'
import FormWorkDay from './FormWorkDay'

export default function ModalAddWorkDay({ handleClose, show,handelcreate }) {


    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header >
                <Modal.Title>افزودن روز کاری</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormWorkDay urlWebsilte='/workday'  handleClose={handleClose} handelcreate={handelcreate} />
            </Modal.Body>
           
        </Modal>
    )
}
